import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/website/Login";
import Dashbaord from "./components/setup/Dashbaord";
import ModernDashboard from "./components/setup/ModernDashboard";

// Setup
import SignUp from "./components/setup/SignUp";

// General Management Components
import AddNewMenu from "./components/setup/AddNewMenu";

// Admin Management Components
import SetUserRights from "./components/AdminManagement/SetUserRights";
import Departments from "./components/AdminManagement/Departments";
import Untis from "./components/AdminManagement/Units";
import ChangePasswordForm from "./components/AdminManagement/ChangePassword";
import ShiftPage from "./components/AdminManagement/ShiftManagement";
import Allowances from "./components/AdminManagement/Allowances";
import GazettedHoliday from "./components/AdminManagement/GazettedHoliday";

// Payroll Management Components
import EmployeeRegistration from "./components/PayrollManagement/EmployeeRegistration";
import EmployeeList from "./components/PayrollManagement/EmployeeList";
import ManualAttendanceForm from "./components/PayrollManagement/ManualAttendanceForm";
import CurrentDayAttendance from "./components/PayrollManagement/CurrentDayAttendance";
import IndividualAttendanceSheet from "./components/PayrollManagement/IndividualAttendanceSheet";
import Resign from './components/PayrollManagement/Resign'
import OvertimeAdjusterMUI from "./components/PayrollManagement/OverAdjustment";
import LeavesManagementList from "./components/AdminManagement/LeavesManagementList";

// Payroll Reports
import DateWiseAttReport from './components/PayrollReports/AttendanceReportPDF'
import EmployeeDetails from "./components/PayrollReports/EmployeeDetails";
import SalarySheet from "./components/PayrollReports/SalarySheet";
import TempSalary from "./components/PayrollReports/TempSalary";
import EmployeeAdvancePage from "./components/PayrollManagement/EmpAdvance";
import Designations from "./components/AdminManagement/Designations";
import EmployeeLeaveApplication from "./components/PayrollManagement/EmployeeLeaveApplication";
import LeaveApprovalManagement from "./components/PayrollManagement/LeaveApprovalManagement";

const theme = createTheme({
  palette: {
    primary: {
      main: '#1E90FF'
    },
    secondary: {
      main: '#ffffff',
    },
    custom: {
      main: "#ffffff"
    }
  },
  typography: {
    fontFamily: [
      // 'Noto Nastaliq Urdu',
      // 'Arial',
      'Helvetica'
    ].join(','),
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>



          {/* General Management Routes */}
          <Route exact path="/" element={<SignUp />} />
          <Route path="/MenuSetup" element={<AddNewMenu />} />

          {/* Admin Management Routes */}
          <Route path="/SetUserRights" element={<SetUserRights />} />
          <Route path="/Departments" element={<Departments />} />
          <Route path="/Designations" element={<Designations />} />
          <Route path="/Units" element={<Untis />} />
          <Route path="/ChangePassword" element={<ChangePasswordForm />} />
          <Route path="/ChangePassword" element={<ChangePasswordForm />} />
          <Route path="/Allowances" element={<Allowances />} />
          <Route path="/Allowances" element={<Allowances />} />
          <Route path="/LeavesManagement" element={<LeavesManagementList />} />
          <Route path="/GazettedHoliday" element={<GazettedHoliday />} />

          {/* Payroll Management */}
          <Route path="/EmployeeList" element={<EmployeeList />} />
          <Route path="/EmployeeRegistration" element={<EmployeeRegistration />} />
          <Route path="/CurrDayAtt" element={<CurrentDayAttendance />} />
          <Route path="/ManualAttendance" element={<ManualAttendanceForm />} />
          <Route path="/IndividualAttSheet" element={<IndividualAttendanceSheet />} />
          <Route path="/Shifts" element={<ShiftPage />} />
          <Route path="/EmpAdvance" element={<EmployeeAdvancePage />} />
          <Route path="/Resign" element={<Resign />} />
          <Route path="/OvertimeAdjustment" element={<OvertimeAdjusterMUI />} />
          <Route path="/EmployeeLeaveApplication" element={<EmployeeLeaveApplication />} />
          <Route path="/LeaveApprovalManagement" element={<LeaveApprovalManagement />} />

          {/* Setup Component */}
          <Route path="/Login" element={<Login />} />
          <Route path="/DashBaord" element={<Dashbaord />} />
          <Route path="/Dashboard" element={<ModernDashboard />} />

          {/* Payroll Reports */}
          <Route path="/DateWiseAttendanceReport" element={<DateWiseAttReport />} />
          <Route path="/EmployeeDetails" element={<EmployeeDetails />} />
          <Route path="/SalarySheet" element={<SalarySheet />} />
          <Route path="/TempSalary" element={<TempSalary />} />


        </Routes>
      </BrowserRouter>
    </ThemeProvider>

  );
}

export default App;
